module.exports = __webpack_public_path__ + "static/media/background-mask-mobile.d3b3aa0b.svg";